import i18n from './i18n';
export default {
  required: value => !!value || 'Field is required',
  exact_length: length => {
    return function (value) {
      if (value && value.length != length) {
        return 'This Field should have ' + length + ' characters';
      }
      return true;
    };
  },
  min_length: length => {
    return function (value) {
      if (value && value.length < length) {
        return 'Minimum length ' + length + ' is required';
      }
      return true;
    };
  },
  max_length: length => {
    return function (value) {
      if (value && value.length > length) {
        return i18n.t ('rms.validation.max_length', {length: length});
      }
      return true;
    };
  },
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value) {
      return pattern.test (value) || 'invalid email';
    }
    return true;
  },
  url: value => {
    const pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(facebook|zoom)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    if (value) {
      return pattern.test (value) || 'invalid url';
    }
    return true;
  },
  numeric: value => {
    const pattern = /^\d+$/;
    return pattern.test (value) || 'It must be numeric';
  },
  inBetween: (min, max, value) => {
    return (
      (value >= min && value <= max) ||
      'It must be in range of ' + min + ' to ' + max + '.'
    );
  },
  floating_number: value => {
    const pattern = /^\d+(\.\d+)?$/;
    if (value) {
      return pattern.test (value) || 'Invalid number';
    }
    return true;
  },
  greaterThanZero: value => {
    if (value && value <= 0) {
      return i18n.t('rms.validation.greaterThanZero');
    }
    return true;
  },
  englishCharacters: value => {
    const pattern = /^[ A-Za-z0-9_@./#&+-]*$/;
    return (
      pattern.test (value) ||
      'Only English alphanumeric and special characters are allowed '
    );
  },
  greaterThanDate: (date, value) => {
    if (value && date >= value) {
      return 'Date must be greater than ' + date;
    }
    return true;
  },
  subdomain: value => {
    // Allow only characters, digits & hyphen
    const regex = /[^a-zA-Z0-9\-]/g;
    if (value) {
      return !regex.test (value) || 'Invalid subdomain';
    }
    return true;
  },
  alphaNumericCharacters: value => {
    const pattern = /^[a-zA-Z0-9]+$/;
    return (
      pattern.test (value) ||
      'Only alphanumeric characters are allowed'
    );
  },
  paymentDescriptor: value => {
    const regex = /[<>"'*\\]/g;
    if (value) {
      return !regex.test (value) || 'Invalid descriptor. Descriptors can’t use special characters such as <, >, ", \', * or \\';
    }
    return true;
  },
};
